/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SinglePicker from '@/components/Base/SinglePicker';
import Popup from "vux/src/components/popup/index.vue";
import ViewBox from "vux/src/components/view-box/index.vue";
import PopupPicker from "vux/src/components/popup-picker/index.vue";
import Group from "vux/src/components/group/index.vue";
import XInput from "vux/src/components/x-input/index.vue";
import ScrollerList from '@/components/ScrollerList';
import ScrollerItem from '@/components/ScrollerList/ScrollerItem';
import SearchBar from '@/components/SearchBar';
import ExtField from '@/components/ExtField';
import { getLinkPersonList, getCustomerExtField as _getCustomerExtField } from '@/api';
import FlowList from '@/components/ScrollerList/FlowList';
import CustomSearch from '@/components/Base/CustomSearch';
export default {
  components: {
    Popup: Popup,
    ViewBox: ViewBox,
    PopupPicker: PopupPicker,
    Group: Group,
    ScrollerList: ScrollerList,
    ScrollerItem: ScrollerItem,
    SearchBar: SearchBar,
    ExtField: ExtField,
    FlowList: FlowList,
    SinglePicker: SinglePicker,
    XInput: XInput,
    CustomSearch: CustomSearch
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showMask: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      customerExtField: [],
      search: {},
      currValue: this.value,
      pageIndex: 0,
      pageSize: 10,
      keyword: '',
      list: []
    };
  },
  computed: {
    // 计算滚动区域高度
    scrollerHight: function scrollerHight() {
      // eslint-disable-next-line standard/computed-property-even-spacing
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return document.documentElement.clientHeight - 4 * fontSize;
    }
  },
  watch: {
    value: function value(val) {
      this.currValue = val;

      if (val) {
        this.resetList();
      }
    },
    currValue: function currValue(val) {
      this.$emit('input', val);
    }
  },
  methods: {
    loadList: function loadList() {
      var _this = this;

      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (reset) {
        this.pageIndex = 0;
        this.$vux.loading.show({
          text: '加载中...'
        });
      }

      var data = _objectSpread({
        pageIndex: this.pageIndex++,
        pageSize: this.pageSize,
        keyword: this.keyword
      }, this.search);

      getLinkPersonList(data).then(function (res) {
        _this.$refs['linkPersonList'] && _this.$refs['linkPersonList'].donePullup();
        _this.$refs['linkPersonList'] && _this.$refs['linkPersonList'].donePulldown();

        if (res.success) {
          if (!reset) {
            _this.list = [].concat(_toConsumableArray(_this.list), _toConsumableArray(res.data));
          } else {
            _this.list = res.data;

            _this.$vux.loading.hide();
          }

          if (res.data.length < _this.pageSize) {
            _this.$refs['linkPersonList'] && _this.$refs['linkPersonList'].disablePullup();
          }

          if (res.data.length === _this.pageSize) {
            _this.$refs['linkPersonList'] && _this.$refs['linkPersonList'].enablePullup();
          }
        } else {// 暂缺
        }
      });
    },
    reset: function reset() {
      this.search = {};
      this.$refs.CustomSearch.forEach(function (v) {
        return v.resetFields();
      });
      this.loadList(true);
    },
    resetList: function resetList() {
      this.list = [];
      this.pageIndex = 0;
      this.$refs['linkPersonList'] && this.$refs['linkPersonList'].enablePullup();
      this.loadList();
    },
    onPulldownLoading: function onPulldownLoading() {
      this.resetList();
    },
    onPullupLoading: function onPullupLoading() {
      this.loadList();
    },
    getCustomerExtField: function getCustomerExtField() {
      var _this2 = this;

      _getCustomerExtField().then(function (res) {
        if (res.success) {
          _this2.customerExtField = res.data;
        }
      });
    }
  },
  created: function created() {
    this.getCustomerExtField();
  }
};